import NewsCard from "../../Components/NewsCard/newsCard"
function News() {
    return (
        <>
            <main>
                <NewsCard />
            </main>
        </>
    )
}

export default News